import React, { PureComponent } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { withRouter } from "react-router-dom";
// import ProductGallery from '../../../../components/catalog/ProductGallery';
// import ProductTabs from './ProductTabs';
// import StarIcon from 'mdi-react/StarIcon';
// import StarOutlineIcon from 'mdi-react/StarOutlineIcon';
import "video-react/dist/video-react.css";
import { Player } from "video-react";
import $ from 'jquery';

class VideoCard extends PureComponent {
  componentDidMount() {
    $(document).bind("contextmenu", function (e) {
      return false;
    });
  }

  componentWillUnmount() {
    $(document).unbind("contextmenu")
  }
  render() {
    const { currentVideo, currentType } = this.props;
    // console.log(currentProduct)
    // console.log("current Video card", currentVideo)
    return (
      <Col md={12} lg={12}>
        <button
          className="btn btn-secondary"
          onClick={() => {
            this.props.history.push(`/app/training/${currentType}`);
          }}
          style={{
            float: "left"
          }}
        >
          {" "}
          {"<< Back To Training"}
        </button>
        {currentVideo ? (
          <React.Fragment>
            <Card>
              <CardBody>
                <div className="video-card">
                  <Player
                    playsInline
                    poster={currentVideo.thumbnail}
                    src={currentVideo.video}
                    onClick={e => {
                      console.log("click");
                    }}
                  />
                  <h5 className="video_title"> {currentVideo.title} </h5>
                  <p className="video_time"> {currentVideo.time} </p>
                  {/* <p className="video_description"> {currentVideo.description} </p> */}
                </div>
              </CardBody>
            </Card>

          </React.Fragment>
        ) : null}
      </Col>
    );
  }
}

export default (withRouter(VideoCard))



// WEBPACK FOOTER //
// ./src/components/training/components/VideoCard.js